import { render, staticRenderFns } from "./formButton.vue?vue&type=template&id=0ea0dcd6&scoped=true"
import script from "./formButton.vue?vue&type=script&lang=js"
export * from "./formButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea0dcd6",
  null
  
)

export default component.exports